import { mapEmbedUrl } from "../../data/contactData";

export default function ContactMapCard({
  HeaderIcon,
  FooterIcon,
  ActionIcon,
  mapSearchUrl,
}) {
  return (
    <article className="contact-map-card reveal-on-scroll reveal-on-scroll--right reveal-delay-2">
      <div className="contact-map-card__header">
        <div className="contact-map-card__header-icon">
          <HeaderIcon />
        </div>

        <div>
          <h3>Onde estamos</h3>
          <p>Localização para facilitar seu atendimento e deslocamento.</p>
        </div>
      </div>

      <div className="contact-map-card__map">
        <iframe
          title="Mapa da clínica"
          src={mapEmbedUrl}
          loading="lazy"
          allowFullScreen
        />
      </div>

      <div className="contact-map-card__footer">
        <div className="contact-map-card__footer-icon">
          <FooterIcon />
        </div>

        <div>
          <strong>Atendimento com hora marcada</strong>
          <span>Segunda a sexta: 08h às 19h • Sábado: 08h às 13h</span>
        </div>

        {mapSearchUrl && (
          <a href={mapSearchUrl} target="_blank" rel="noreferrer">
            Ver rota
            <ActionIcon />
          </a>
        )}
      </div>
    </article>
  );
}